export function setFavicon(customer) {
    const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link');
    favicon.type = 'image/x-icon';
    favicon.rel = 'shortcut icon';
    favicon.href = customer === 'BH' ? '/logoBH.ico' : '/logoPK.ico';

    if (!document.querySelector("link[rel*='icon']")) {
        document.getElementsByTagName('head')[0].appendChild(favicon);
    }
}